// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import GridsGridLine from '../../components/grid/GridsGridLine';
import { getGridLine } from '../../selectors/grid';

const legacySelector = memoize(getGridLine);

type GridsGridLineContainerProps = {
  className?: string;
  matchId: number;
  selection: string;
  resultSelection?: string;
  matchIndex: number;
  isSystemCompact?: boolean;
  isClosedPool?: boolean;
  hideInfo?: boolean;
  isBasket?: boolean;
};

const GridsGridLineContainer = ({
  selection,
  resultSelection,
  isSystemCompact,
  isClosedPool,
  ...ownProps
}: GridsGridLineContainerProps) => {
  const { matchId, matchIndex, hideInfo, isBasket } = ownProps;

  const selectedProps = useSelector((state) =>
    legacySelector(state, {
      matchId,
      selection,
      resultSelection,
      matchIndex,
      isSystemCompact,
      isClosedPool,
      hideInfo,
      isBasket,
    }),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsGridLine {...enhancedProps} />;
};

export default GridsGridLineContainer;
